<!-- 分析范围设置 -->
<template>
  <Split v-model="splitValue1">
    <div slot="left" style="height:100%;overflow-y:auto; padding: 0 5px 0 10px;">
      <!-- 左侧全局设置：begin -->
      <Table
        border
        size="small"
        :columns="leftTableColumns"
        :data="leftTableData"
        highlight-row
        ref="leftTable"
        :height="leftTableHeight"
        @on-row-click="onClickLeftTable"
      ></Table>
      <!-- 左侧全局设置：end -->
    </div>
    <Split v-model="splitValue2" slot="right">
      <div slot="left" style="height:100%;overflow-y:auto; padding: 0 5px 0 10px;width: 100%;">
        <!-- 中间车辆分组：begin -->
        <Table
          border
          size="small"
          :columns="middleTableColumns"
          :data="middleTableData"
          highlight-row
          ref="middleTable"
          :height="middleTableHeight"
        ></Table>
        <div style="margin-top:10px;">
          <!--<Input v-model="middleSearchMsg" placeholder="搜索" style="width: 300px;" :disabled="middleDisabled" />-->
          <Select
            v-model="middleModalTableSearchMsg"
            filterable
            multiple
            remote
            :remote-method="searchMiddleModalTableData"
            :loading="isShowBindVehicleInfoGroupModalSearchLoading"
            style="width: 400px;"
            size="small"
          >
            <Option v-for="(option, index) in middleModalTableSearchData" :value="option.id" :key="index">
              {{option.text}}
            </Option>
          </Select>
          <Button type="primary" size="small" style="margin-left:3px;" :disabled="middleDisabled"
                  @click="saveBindVehicleInfoGroup">添加
          </Button>
        </div>
        <!-- 添加分组模态框 -->
        <!--
        <Modal v-model="isShowBindVehicleInfoGroupModal" title="添加车辆分组">
            <div class slot="footer">
                <Button type="text" @click="cancelBindVehicleInfoGroup">取消</Button>
                <Button type="primary" :loading="isShowBindVehicleInfoGroupModalLoading" @click="saveBindVehicleInfoGroup">确定</Button>
            </div>
            <div>
                <div style="padding-bottom: 3px;">
                    <Select
                        v-model="middleModalTableSearchMsg"
                        filterable
                        multiple
                        remote
                        :remote-method="searchMiddleModalTableData"
                        :loading="isShowBindVehicleInfoGroupModalSearchLoading"
                        style="width: 400px;"
                        size="small"
                    >
                        <Option v-for="(option, index) in middleModalTableSearchData" :value="option.text" :key="index">{{option.text}}</Option>
                    </Select>
                    <Button
                        type="primary"
                        size="small"
                        style="margin-left:3px;"
                        :loading="isShowBindVehicleInfoGroupModalSearchLoading"
                        @click="searchBindVehicleInfoGroup"
                    >查询</Button>
                </div>
                <Table
                    border
                    size="small"
                    :columns="middleModalTableColumns"
                    :data="middleModalTableData"
                    highlight-row
                    ref="middleModalTable"
                    :height="300"
                ></Table>
            </div>
        </Modal>
        -->
        <!-- 中间车辆分组：end -->
      </div>
      <div slot="right" style="height:100%;overflow-y:auto; padding: 0 5px 0 10px;width: 100%;">
        <!-- 右边车辆列表：begin -->
        <Table
          border
          size="small"
          :columns="rightTableColumns"
          :data="rightTableData"
          highlight-row
          ref="rightTable"
          :height="rightTableHeight"
        ></Table>
        <div style="margin-top:10px;">
          <Select
            v-model="rightModalTableSearchMsg"
            filterable
            multiple
            remote
            :remote-method="searchRightModalTableData"
            :loading="isShowBindVehicleInfoModalSearchLoading"
            style="width: 400px;"
            size="small"
          >
            <Option v-for="(option, index) in rightModalTableSearchData" :value="option.id" :key="index">
              {{option.text}}
            </Option>
          </Select>
          <Button type="primary" size="small" style="margin-left:3px;" :disabled="rightDisabled"
                  @click="saveBindVehicleInfo">添加
          </Button>
        </div>
        <!-- 添加车辆模态框 -->
        <!--
        <Modal v-model="isShowBindVehicleInfoModal" title="添加车辆分组">
            <div class slot="footer">
                <Button type="text" @click="cancelBindVehicleInfo">取消</Button>
                <Button type="primary" :loading="isShowBindVehicleInfoModalLoading" @click="saveBindVehicleInfo">确定</Button>
            </div>
            <div>
                <div style="padding-bottom: 3px;">
                    <Select
                        v-model="rightModalTableSearchMsg"
                        filterable
                        multiple
                        remote
                        :remote-method="searchRightModalTableData"
                        :loading="isShowBindVehicleInfoModalSearchLoading"
                        style="width: 400px;"
                        size="small"
                    >
                        <Option v-for="(option, index) in rightModalTableSearchData" :value="option.text" :key="index">{{option.text}}</Option>
                    </Select>
                    <Button
                        type="primary"
                        size="small"
                        style="margin-left:3px;"
                        :loading="isShowBindVehicleInfoModalSearchLoading"
                        @click="searchBindVehicleInfo"
                    >查询</Button>
                </div>
                <Table
                    border
                    size="small"
                    :columns="rightModalTableColumns"
                    :data="rightModalTableData"
                    highlight-row
                    ref="rightModalTable"
                    :height="300"
                ></Table>
            </div>
        </Modal>
        -->
        <!-- 右边车辆列表：end -->
      </div>
    </Split>
  </Split>
</template>

<script>
import store from '../../store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'analysisscopesetting',
  data: function () {
    return {
      splitValue1: 0.3,
      splitValue2: 0.5,

      // 当前选中项的设置信息
      // 0代表全局设置，分组和车辆不可用
      // 1代表车辆和分组都可用
      currentRangeType: -1,
      // 当前设置的类型的id
      currentSettingID: -1,
      // 当前选中的左侧的序号
      currentSelectIndex: -1,

      // 左侧全局设置table列
      leftTableData: [],
      leftTableHeight: 160,
      leftTableColumns: [
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          align: 'center'
        },
        {
          title: '名称',
          key: 'name',
          width: 300,
          resizable: true,
          align: 'center'
        },
        {
          title: '全局设置',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 90,
          render: (h, params) => {
            return h('div', [
              h(
                'i-switch',
                {
                  props: {
                    size: 'small',
                    value: params.row.rangeType === 0
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    'on-change': value => {
                      // value.stopPropagation()
                      // 切换开关事件
                      this.leftTableData[params.index].rangeType = value
                        ? 0
                        : 1
                      this.currentRangeType = value ? 0 : 1
                      // 开关只有2个值，怎么设置3个状态（只使用0和1）
                      // this.changeGlobalSettings(params.row.id, value ? 0 : 1)

                      this.handleRender(params.row, value ? 0 : 1)
                    }
                  }

                },
                ''
              ),
              h('div',
                {
                  style: {
                    display: 'contents'
                  }
                }
              ),
              params.row.rangeType == 1 ? '关' : '开'
            ])
          }
        }
      ],
      // 中间车辆分组列
      isShowBindVehicleInfoGroupModal: false, // 显示添加车辆分组模态框
      isShowBindVehicleInfoGroupModalLoading: false, // 车辆分组模态框loading
      middleSearchMsg: '', // 车辆分组搜索信息
      middleTableData: [], // 已经绑定的车辆信息
      middleTableHeight: 160, // 车辆分组表格高度
      middleTableColumns: [
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          align: 'center'
        },
        {
          title: '分组名称',
          key: 'vehicleInfoGroupName',
          width: 300,
          resizable: true,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: this.middleDisabled
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除',
                        content: '是否确定删除？',
                        onOk: () => {
                          this.unBindVehicleInfoGroups(this.currentSettingID, [
                            params.row.id
                          ])
                        }
                      })
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ],
      // 中间车辆分组添加模态框的字段列表
      middleModalTableSearchData: [], // 搜索结果列表
      middleModalTableSearchMsg: [], // 中间车辆分组模态框搜索的内容
      isShowBindVehicleInfoGroupModalSearchLoading: false, // 中间车辆分组模态框搜索是否正在进行
      middleModalTableData: [],
      middleModalTableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'id',
          key: 'id',
          width: 60,
          align: 'center'
        },
        {
          title: '分组名称',
          key: 'name',
          align: 'center'
        }
      ],

      // 右侧车辆列表列
      isShowBindVehicleInfoModal: false,
      isShowBindVehicleInfoModalLoading: false,
      rightSearchMsg: '',
      rightTableData: [],
      rightTableHeight: 160,
      rightTableColumns: [
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          align: 'center'
        },
        {
          title: '车牌号',
          key: 'registrationNum',
          width: 100,
          resizable: true,
          align: 'center'
        },
        {
          title: '车架号',
          key: 'vin',
          width: 300,
          resizable: true,
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          fixed: 'right',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: this.rightDisabled
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除',
                        content: '是否确定删除？',
                        onOk: () => {
                          this.unBindVehicleInfos(this.currentSettingID, [
                            params.row.id
                          ])
                        }
                      })
                    }
                  }
                },
                '删除'
              )
            ])
          }
        }
      ],
      // 右边车辆添加模态框的字段列表
      rightModalTableSearchData: [], // 搜索结果列表
      rightModalTableSearchMsg: [], // 右边车辆模态框搜索的内容
      isShowBindVehicleInfoModalSearchLoading: false, // 右边车辆模态框搜索是否正在进行
      rightModalTableData: [],
      rightModalTableColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: 'id',
          key: 'id',
          width: 65,
          resizable: true,
          align: 'center'
        },
        {
          title: '车牌号',
          key: 'registrationNum',
          width: 300,
          resizable: true,
          align: 'center'
        },
        {
          title: '车架号',
          key: 'vin',
          width: 300,
          resizable: true,
          align: 'center'
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(() => {
      // 窗口的大小自适应
      this.leftTableHeight =
          window.innerHeight - this.$refs.leftTable.$el.offsetTop - 90
      this.middleTableHeight =
          window.innerHeight - this.$refs.middleTable.$el.offsetTop - 130
      this.rightTableHeight =
          window.innerHeight - this.$refs.rightTable.$el.offsetTop - 130
      window.onresize = () => {
        this.leftTableHeight =
            window.innerHeight - this.$refs.leftTable.$el.offsetTop - 90
        this.middleTableHeight =
            window.innerHeight - this.$refs.middleTable.$el.offsetTop - 130
        this.rightTableHeight =
            window.innerHeight - this.$refs.rightTable.$el.offsetTop - 130
      }
    })

    // 初始化数据
    this.getLeftTableData()
  },
  computed: {
    // 中间区域是否禁用
    middleDisabled () {
      if (this.currentSelectIndex < 0) {
        return true
      }
      // return this.currentRangeType === 0
      return this.leftTableData[this.currentSelectIndex].rangeType === 0
    },
    // 右侧区域是否可编辑
    rightDisabled () {
      if (this.currentSelectIndex < 0) {
        return true
      }
      // return this.currentRangeType === 0
      return this.leftTableData[this.currentSelectIndex].rangeType === 0
    }
  },
  methods: {
    // 打开全局范围设置
    handleRender (e, value) {
      // console.log(e)
      console.log(value)
      let Type
      if (e.rangeType == 0) {
        Type = '关闭'
      } else {
        Type = '打开'
      }
      this.$Modal.confirm({
        title: '确认' + Type + '全局设置',
        onOk: () => {
          console.log('确定')
          this.changeGlobalSettings(e.id, value ? 1 : 0)
        },
        onCancel: () => {
          console.log('取消')
          this.leftTableData[e._index].rangeType = value
            ? 0
            : 1
          this.currentRangeType = value ? 0 : 1
        }
      })
    },
    /**
       * 左侧：全局选项
       */
    // 获取左侧表格数据：AnalysisRangeServ_GetPage
    getLeftTableData () {
      store
        .dispatch('AnalysisRangeServ_GetPage', {
          params: null,
          urlparams: null
        })
        .then(res => {
          // console.log(res)
          // vehicleInfos：车辆ID
          // analysisRangeVehicleInfoGroupItems：分组ID
          this.leftTableData = res.data.content
          if (this.currentSettingID > 0) {
            this.onClickLeftTable(
              res.data.content[this.currentSelectIndex],
              this.currentSelectIndex
            )
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 点击左侧行数据：显示当前绑定的车辆、分组、全局设置
    onClickLeftTable (row, index) {
      console.log(this.$refs.leftTable)
      this.middleTableData = row.analysisRangeVehicleInfoGroupItems || []
      this.rightTableData = row.vehicleInfos || []
      this.currentRangeType = row.rangeType
      this.currentSettingID = row.id
      this.currentSelectIndex = index
    },
    // 左侧全局开关修改时：AnalysisRangeServ_ModifyObj
    changeGlobalSettings (id, rangeType) {
      store
        .dispatch('AnalysisRangeServ_ModifyObj', {
          params: {
            id: id,
            rangeType: rangeType
          },
          urlparams: null
        })
        .then(res => {
          console.log(res)
        })
        .catch(err => {
          console.log(err)
        })
    },

    /**
       * 中间：车辆分组设置
       */
    // 显示添加车辆分组的模态框
    showBindVehicleInfoGroupModal () {
      this.isShowBindVehicleInfoGroupModal = true
    },
    // 取消添加车辆分组
    cancelBindVehicleInfoGroup () {
      this.isShowBindVehicleInfoGroupModal = false
    },
    // 搜索下拉列表
    searchMiddleModalTableData (query) {
      store
        .dispatch('VehicleInfoGroupServ_SearchByName', {
          params: {
            name: query
          },
          urlparams: null
        })
        .then(res => {
          this.middleModalTableSearchData = res.data.map(item => {
            return { id: item.id, text: item.name }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 添加车辆分组
    saveBindVehicleInfoGroup () {
      if (
        this.currentSettingID <= 0 ||
          this.middleModalTableSearchMsg.length <= 0
      ) {
        return
      }
      /*
          this.isShowBindVehicleInfoGroupModalLoading = true
          let temp = this.$refs.middleModalTable.getSelection()
          if (temp.length <= 0) {
            this.isShowBindVehicleInfoGroupModalLoading = false
            this.isShowBindVehicleInfoGroupModal = false
          }
          */
      this.bindVehicleInfoGroups(
        this.currentSettingID,
        this.middleModalTableSearchMsg
      )
    },
    // 搜索车辆分组
    searchBindVehicleInfoGroup () {
      this.middleModalTableData = []
      if (this.middleModalTableSearchMsg.length <= 0) {
        return
      }
      let querys = this.middleModalTableSearchMsg.map(item => {
        return store.dispatch('VehicleInfoGroupServ_SearchByName', {
          params: {
            name: item
          },
          urlparams: null
        })
      })
      Promise.allSettled(querys).then(res => {
        let result = []
        res.forEach(item => {
          result = result.concat(
            item.status === 'fulfilled' ? item.value.data : []
          )
        })
        this.middleModalTableData = result
      })
    },
    // 车辆分组添加(id为全局设置的分类的id，groups为车辆分组的id列表，数组类型)
    bindVehicleInfoGroups (id, groupIds) {
      store
        .dispatch('AnalysisRangeServ_BindVehicleInfoGroups', {
          params: {
            id: id,
            vehicleInfoGroupIds: groupIds
          },
          urlparams: null
        })
        .then(res => {
          this.getLeftTableData()
          this.middleModalTableSearchMsg = []
          // this.isShowBindVehicleInfoGroupModal = false
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isShowBindVehicleInfoGroupModalLoading = false
        })
    },
    // 车辆分组删除(id为全局设置的分类的id，groups为车辆分组的id列表，数组类型）
    unBindVehicleInfoGroups (id, groupIds) {
      store
        .dispatch('AnalysisRangeServ_UnBindVehicleInfoGroups', {
          params: {
            id: id,
            vehicleInfoGroupIds: groupIds
          },
          urlparams: null
        })
        .then(res => {
          this.getLeftTableData()
        })
        .catch(err => {
          console.log(err)
        })
    },

    /**
       * 右边：车辆设置
       */
    // 显示添加车辆的模态框
    showBindVehicleInfoModal () {
      this.isShowBindVehicleInfoModal = true
    },
    // 取消添加车辆
    cancelBindVehicleInfo () {
      this.isShowBindVehicleInfoModal = false
    },
    // 保存添加车辆
    saveBindVehicleInfo () {
      if (this.currentSettingID <= 0 || this.rightModalTableSearchMsg.length <= 0) {
        return
      }
      /*
          this.isShowBindVehicleInfoModalLoading = true
          let temp = this.$refs.rightModalTable.getSelection()
          if (temp.length <= 0) {
            this.isShowBindVehicleInfoModalLoading = false
            this.isShowBindVehicleInfoModal = false
            return
          }
          */
      console.log(this.rightModalTableSearchMsg)
      this.bindVehicleInfos(
        this.currentSettingID,
        this.rightModalTableSearchMsg
      )
    },
    // 远程获取下拉数据
    searchRightModalTableData (query) {
      store
        .dispatch('VehicleInfoServ_ClientSearch', {
          params: null,
          urlparams: {
            keyword: query
          }
        })
        .then(res => {
          // console.log(res)
          this.rightModalTableSearchData = res.data.map(item => {
            return { id: item.id, text: item.registrationNum || item.vin }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 搜索车辆
    searchBindVehicleInfo () {
      this.rightModalTableData = []
      if (this.rightModalTableSearchMsg.length <= 0) {
        return
      }
      let querys = this.rightModalTableSearchMsg.map(item => {
        return store.dispatch('VehicleInfoServ_ClientSearch', {
          params: null,
          urlparams: {
            keyword: item
          }
        })
      })
      Promise.allSettled(querys).then(res => {
        let result = []
        res.forEach(item => {
          result = result.concat(
            item.status === 'fulfilled' ? item.value.data : []
          )
        })
        this.rightModalTableData = result
      })
    },
    // 车辆添加(id为全局设置的分类的id，groups为车辆分组的id列表，数组类型）
    bindVehicleInfos (id, groupIds) {
      store
        .dispatch('AnalysisRangeServ_BindVehicleInfos', {
          params: {
            id: id,
            vehicleInfoIds: groupIds
          },
          urlparams: null
        })
        .then(res => {
          this.getLeftTableData()
          this.isShowBindVehicleInfoModal = false
          this.rightModalTableSearchMsg = []
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isShowBindVehicleInfoModalLoading = false
        })
    },
    // 车辆删除(id为全局设置的分类的id，groups为车辆分组的id列表，数组类型）
    unBindVehicleInfos (id, groupIds) {
      console.log(id)
      console.log(groupIds)
      store
        .dispatch('AnalysisRangeServ_UnBindVehicleInfos', {
          params: {
            id: id,
            vehicleInfoIds: groupIds
          },
          urlparams: null
        })
        .then(res => {
          this.getLeftTableData()
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
</script>

<style>
</style>
